import { render, staticRenderFns } from "./Inscripcionrest-add.vue?vue&type=template&id=6bea43a4"
import script from "./Inscripcionrest-add.vue?vue&type=script&lang=js"
export * from "./Inscripcionrest-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports